/**
 * Creates a function that prefixes a given selector with the provided base string.
 *
 * @param {string} base - The base string to use for prefixing.
 * @returns {(selector: string) => string} A function that takes a selector and returns the base and selector concatenated.
 */
const createPrefixedSelector = (base) => (selector) => `${base} ${selector}`;

/**
 * Prefixes each string property (except "base") with the given base.
 *
 * @template T
 * @param {T & { base: string }} group - The object containing a base property and other string properties.
 * @returns {T & { base: string }} - The same object with string properties (other than "base") prefixed.
 */
function withBase(group) {
    const base = group.base;
    const result = { ...group };
    Object.keys(result).forEach((key) => {
        if (key !== "base" && typeof result[key] === "string") {
            result[key] = `${base}${result[key]}`;
        }
    });
    return result;
}

export default {
    createPrefixedSelector,
    withBase,
};

export { createPrefixedSelector, withBase };
